export enum CreationDateSortOptions {
  CREATION_DATE_ASC = "Creation Date Ascending",
  CREATION_DATE_DESC = "Creation Date Descending"
}

export enum TimestampSortOptions {
  TIMESTAMP_DATE_ASC = "Timestamp Ascending",
  TIMESTAMP_DATE_DESC = "Timestamp Descending"
}
